import { Sector } from '@/domain/impact/impact.entity';
import {
  Category,
  ImpactCo2Answer,
  TransportationMode,
  TransportationModeValues,
  ValuesMobility,
} from '@/domain/impact-co2/entities/question.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { ImportedRow } from '../convert-excel-to-impact-answers';
import { buildBaseAnswer } from './common/build-base-answer';
import {
  filterRowsByCategory,
  filterRowsBySectors,
} from './common/filter-rows-by-category';
import { ImportMappingError } from './common/import-mapping.error';

const CATEGORY: Category = 'MOBILITY';
const SECTORS: Sector[] = ['ARTISTS', 'PUBLIC'];

export function mapToMobilityAnswers(
  rows: ImportedRow[],
): ImpactCo2Answer<ValuesMobility>[] {
  return rows
    .filter(filterRowsByCategory(CATEGORY))
    .filter(filterRowsBySectors(SECTORS))
    .map((row) => buildAnswer(row));
}

function buildAnswer(row: ImportedRow) {
  const transportationMode = mapToTransportationMode(row);
  const passengerCount = mapToPassengerCount(row);
  const travelDistance = mapToTravelDistance(row);
  const baseAnswer = buildBaseAnswer(row, CATEGORY);
  const answer = {
    ...baseAnswer,
    values: {
      ...baseAnswer.values,
      transportationMode,
      passengerCount,
      travelDistance,
    },
  };
  return answer;
}

export function mapToTransportationMode(row: ImportedRow): TransportationMode {
  const tgsValue = row['Fairly Sub Category Description'];
  const result = validateValueInType<TransportationMode>(
    tgsValue,
    TransportationModeValues,
  );
  if (!result) {
    throw new ImportMappingError('transportationMode', tgsValue, row);
  }
  return result;
}

export function mapToTravelDistance(row: ImportedRow): number {
  const tgsValue = row['Distance (Km)'];
  const result = parseFloat(tgsValue);
  if (isNaN(result)) {
    throw new ImportMappingError('travelDistance', tgsValue, row);
  }
  return result;
}

export function mapToPassengerCount(row: ImportedRow): number {
  const tgsValue = row['No. Of passengers'];
  const result = parseInt(tgsValue, 10);
  if (isNaN(result)) {
    throw new ImportMappingError('passengerCount', tgsValue, row);
  }
  return result;
}
